import { CollectionStatusTextMap } from '@/utils/constant';
import React, { useEffect, useState } from 'react';
import TravelRoutes from '../TravelRoutes';
import './index.scss';
import classNames from 'classnames';
import { RetweetOutlined } from '@ant-design/icons';
import {
  addGlobalEventListener,
  removeGlobalEventListener,
} from '@/utils/emit';

const MapTaskCard = ({
  realtimeData,
  vehicleName,
}: {
  realtimeData: any;
  vehicleName: string;
}) => {
  const [showTravelRoutes, setShowTravelRoutes] = useState<boolean>(false);

  useEffect(() => {
    const cb = () => {
      setShowTravelRoutes(false);
    };
    addGlobalEventListener('click_finish_collect_btn', cb);
    return () => {
      removeGlobalEventListener('click_finish_collect_btn', cb);
    };
  }, []);

  const minutesToHoursAndMinutes = (minutes: any) => {
    if (minutes == undefined) {
      return null;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}小时${mins}分钟`;
  };
  return (
    <div className="map-task-card">
      <div
        className={classNames('toggle-map-mode', {
          'change-color': showTravelRoutes,
        })}
        onClick={() => {
          setShowTravelRoutes(!showTravelRoutes);
        }}
      >
        <RetweetOutlined />
      </div>

      <div
        className={classNames('collect-task-info', {
          active: !showTravelRoutes,
          inactive: showTravelRoutes,
        })}
      >
        <img
          src={require('@/assets/images/collectMap/singleview/arrow-group-down.png')}
          alt=""
        />
        <ul className="collect-task-info-list">
          <li>
            <div className="label">任务名称</div>
            <div className="content">{realtimeData?.taskName ?? '--'}</div>
          </li>
          <li>
            <div className="label">采集状态</div>
            <div className="content">
              {realtimeData?.collectionStatus
                ? CollectionStatusTextMap.get(realtimeData?.collectionStatus)
                : '--'}
            </div>
          </li>
          <li>
            <div className="label">子任务数</div>
            <div className="content">
              {realtimeData?.subTaskQuantity ?? '--'}
            </div>
          </li>
          <li>
            <div className="label">任务采集用时</div>
            <div className="content">
              {minutesToHoursAndMinutes(realtimeData?.workingTime) ?? '--'}
            </div>
          </li>
        </ul>
        <img
          src={require('@/assets/images/collectMap/singleview/arrow-group-up.png')}
          alt=""
        />
      </div>
      <div
        className={classNames('travel-routes-css-div', {
          active: showTravelRoutes,
          inactive: !showTravelRoutes,
        })}
      >
        <TravelRoutes
          vehicleName={vehicleName}
          show={showTravelRoutes}
          latitude={realtimeData?.latitude}
          longitude={realtimeData?.longitude}
          taskId={realtimeData?.taskId}
          rotation={realtimeData?.realHeading}
          collectionStatus={realtimeData?.collectionStatus}
        />
      </div>
    </div>
  );
};

export default React.memo(MapTaskCard);
